import { call, put, takeLatest, select } from "redux-saga/effects";
import { PROYECT, api_get } from "services/api";
import { BLUE_RGB, GREEN_RGB } from "utils/colorsTheme";

import {
  getStations,
  orderCompaniesAndStations,
} from "helpers/companiesNormalized";
import { setSnackbar } from "redux/actions/search/searchActions";

export const types = {
  CLEAR: "CLEAR",
  // data
  LOAD_DATA: "LOAD_DATA",
  SET_DATA: "SET_DATA",
  ERROR_DATA: "ERROR_DATA",
  // profits
  LOAD_PROFITS: "LOAD_PROFITS",
  SET_PROFITS: "SET_PROFITS",
  ERROR_PROFITS: "ERROR_PROFITS",
  // filters
  CHANGE_COMPANIES: "CHANGE_COMPANIES",
};

const INITIAL_STATE = {
  profits: [],
  graphs: [],
  isLoading: false,

  // filters
  companies: [],
  isLoadingFilters: false,
  companiesSelected: [],
};

export const profitStationReducer = (
  state = INITIAL_STATE,
  { type, payload }
) => {
  switch (type) {
    // data
    case types.LOAD_DATA:
      return {
        ...state,
        companies: [],
        isLoadingFilters: true,
      };
    case types.SET_DATA:
      return {
        ...state,
        companies: payload.companies,
        isLoadingFilters: false,
      };
    case types.ERROR_DATA:
      return {
        ...state,
        isLoadingFilters: false,
      };
    // profits
    case types.LOAD_PROFITS:
      return {
        ...state,
        graphs: [],
        isLoading: true,
      };
    case types.SET_PROFITS:
      return {
        ...state,
        graphs: payload.graphs,
        isLoading: false,
      };
    case types.ERROR_PROFITS:
      return {
        ...state,
        isLoading: false,
      };

    // filters
    case types.CHANGE_COMPANIES:
      return {
        ...state,
        companiesSelected: payload.companies,
      };

    // general
    case types.CLEAR:
      return {
        ...state,
        ...INITIAL_STATE,
      };

    default:
      return state;
  }
};

// Actions
// data
export function getData() {
  return {
    type: types.LOAD_DATA,
  };
}
// Prices
export function getProfits(companies) {
  return {
    type: types.LOAD_PROFITS,
    payload: {
      companies,
    },
  };
}
export function clearFiles() {
  return {
    type: types.CLEAR,
  };
}

// Filters
export function changeCompanies(companies) {
  return {
    type: types.CHANGE_COMPANIES,
    payload: { companies },
  };
}

// sagas
function* fetchData() {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const url = `${process.env.REACT_APP_URL}${PROYECT}/companies`;
  try {
    const response = yield call(api_get, url, auth);

    const stations = getStations(response.companies);
    const orderedCompanies = orderCompaniesAndStations(response.companies);

    const companiesNormalized = orderedCompanies.map((company) => {
      return {
        ...company,
        value: company.id,
        label: company.name,
      };
    });
    const stationsNormalized = stations.map((station) => {
      return {
        value: station.id,
        label: `${station.company} - ${station.name}`,
      };
    });

    yield put({
      type: types.SET_DATA,
      payload: {
        companies: companiesNormalized,
        stations: stationsNormalized,
      },
    });
  } catch (message) {
    yield put({
      type: types.ERROR_DATA,
    });
    yield put(setSnackbar(message, "danger"));
  }
}
function* fetchProfits(action) {
  const {
    payload: { companies = [] },
  } = action;

  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}/prices/graphs/companies?`;
  let urlCompanies = ``;

  companies.forEach((station, index) => {
    if (index === 0) {
      urlCompanies = `${urlCompanies}companies=${station.value}`;
    } else {
      urlCompanies = `${urlCompanies}&companies=${station.value}`;
    }
  });
  const url = `${baseUrl}${urlCompanies}`;

  try {
    const response = yield call(api_get, url, auth);
    const newGraphs = response.map((company) => {
      return {
        ...company,
        datasets: company.datasets
          ? company.datasets.map((dataset) => {
              return {
                ...dataset,
                fill: false,
                backgroundColor: BLUE_RGB,
                borderColor: BLUE_RGB,
              };
            })
          : [],

        stations: company.stations.map((station) => {
          return {
            ...station,
            history: {
              ...station.history,
              datasets: station.history.datasets
                ? station.history.datasets.map((dataset) => ({
                    ...dataset,
                    fill: false,
                    backgroundColor: BLUE_RGB,
                    borderColor: BLUE_RGB,
                  }))
                : [],
            },
            profit: {
              ...station.profit,
              datasets: station.profit.datasets
                ? station.profit.datasets.map((dataset, index) => ({
                    ...dataset,
                    fill: false,
                    backgroundColor: index === 0 ? GREEN_RGB : BLUE_RGB,
                    borderColor: index === 0 ? GREEN_RGB : BLUE_RGB,
                  }))
                : [],
            },
          };
        }),
      };
    });

    yield put({
      type: types.SET_PROFITS,
      payload: {
        graphs: newGraphs,
      },
    });
  } catch (message) {
    yield put({
      type: types.ERROR_PROFITS,
    });
    yield put(setSnackbar(message, "danger"));
  }
}

export function* profitStationSaga() {
  yield takeLatest(types.LOAD_DATA, fetchData);
  yield takeLatest(types.LOAD_PROFITS, fetchProfits);
}
